
import Request from "./request";
import Workers from "./workers";
import Projects from "./projects";
import Instances from "./instances";
import Instance from "./instance";
import Apps from "./apps";
import App from "./app";
import Teams from "./teams";
import Team from "./team";
import Worker from "./worker";
import Function from "./function";
import User from "./user";
import Functions from "./functions";

class Cognition {
    
    constructor(config = {}) {
        let apiKey = config.apiKey || null;
        this.request = new Request(apiKey);
        this.workers = new Workers(this.request);
        this.projects = new Projects(this.request);
        this.instances = new Instances(this.request);
        this.apps = new Apps(this.request);
        this.teams = new Teams(this.request);
        this.functions = new Functions(this.request);
        this.user = new User(this.request);
    }

    instance(_instanceId) {
        return new Instance(_instanceId, this.request);
    }

    app(_appId) {
        return new App(_appId, this.request);
    }

    team(_teamId) {
        return new Team(_teamId, this.request);
    }

    worker(_identity) {
        return new Worker(_identity, this.request);
    }

    function(_identity) {
        return new Function(_identity, this.request);
    }

}

module.exports = Cognition;